import React from "react";
import { CarouselLayout } from "./Layout/Carousel";
import { StackedLayout } from "./Layout/Stacked";
import { TiledLayout } from "./Layout/Tiled";
import { ThumbnailLayout } from "./Layout/Thumbnail";
import { SingleImageLayout } from "./Layout/SingleImage";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export const ProductGallery = ({
  images,
  onImageClick,
  videoUrl,
  settings,
}) => {
  const { section } = settings;
  const isMobile = useMobileBreakpoint(section.mobile_breakpoint);

  let galleryType = isMobile
    ? section.gallery_type_mobile
    : section.gallery_type;

  const renderGallery = () => {
    switch (galleryType) {
      case "tiled":
        return <TiledLayout settings={settings} images={images} videoUrl={videoUrl} />;
      case "stacked":
        return <StackedLayout settings={settings} images={images} />;
      case "carousel":
        return <CarouselLayout settings={settings} images={images} videoUrl={videoUrl} />;
      case "thumbnail":
        return <ThumbnailLayout settings={settings} images={images} />;
      case "single":
        return <SingleImageLayout settings={settings} images={images} image={images[0]} />;
      default:
        return null;
    }
  };

  return (
      <div className={`product-gallery__${galleryType}`}>{renderGallery()}</div>
  );
};
